import React from 'react';

const PUBLIC = process.env.PUBLIC_URL || '';

/**
 * The full Zaptude lockup — mark + wordmark, one image (client/public/branding/zaptude-logo-tagline.svg,
 * the exact supplied asset, never redrawn or reset in another font). Reserved for hero/brand moments
 * (Login) where the wordmark itself, not just the icon, should read as the logo. Its native aspect
 * ratio is ~1254:773; pass `height` and let width follow, or vice versa.
 */
export default function ZapLogo({ height = 64, className = '' }) {
  return (
    <img
      className={className}
      src={`${PUBLIC}/branding/zaptude-logo-tagline.svg`}
      height={height}
      alt="Zaptude"
      draggable={false}
      style={{ width: 'auto', maxWidth: '100%' }}
    />
  );
}
